import * as StartpageHeroFavourites from "./startpageHeroFavourites";
import * as StartpageHeroLatestVisited from "./startpageHeroLatestVisited";
import * as StartpageHeroNotes from "./startpageHeroEducations";

export function initialize(): void {
    StartpageHeroFavourites.initialize();
    StartpageHeroLatestVisited.initialize();
    StartpageHeroNotes.initialize();

    initializeCoverageMenuItem();
    wireExpansion();
}

const initializeCoverageMenuItem = () => {
    $(".pIMyFavorites").show().addClass("selectedItem");
    $(".pIMyEducations").hide();
    $(".pILatestVisited").hide();

    $("#heromenu_myfavourites").addClass("selectedItem").attr("aria-expanded", "true");/*.focus()*/
    $("#heromenu_myeducations").removeClass("selectedItem");
    $("#heromenu_latestvisited").removeClass("selectedItem");
};

function wireExpansion() {
    $(".hero-menu-trigger").on("click", expand);
}
function expand(event) {
    const $this = $(this);
    const contentID = $this.data("contentid");
  
    if(contentID && !!event){
        event.stopPropagation();
    }

    $(".hero-menu-trigger").removeClass("selectedItem").attr("aria-expanded", "false");
    $(".hero-menu-content__item").removeClass("selectedItem").attr("aria-expanded", "false").hide();
    $($this).addClass("selectedItem").attr("aria-expanded", "true");
    $("." + contentID).show().addClass("selectedItem");
    //ScrollLock.lock();
}

function moveClick(event) {
    event.preventDefault();
}
